import accountStyles from '../account/account-option/account-option.style';
import { useEffect, useMemo, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import game3rdApi from 'apis/game3rdApi';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import { Game3rdTransferModel, itemGame3RD } from 'models/fundTransferModel';
import styles from './fund-transfer.style';
import toast from 'react-hot-toast';
import { removeSeperateNumber } from 'utils/function';
import LoadingIcon from 'components/loading/LoadingIcon';
import { cacheUserInfo } from 'features/authSlice';
import authApi from 'apis/authApi';
import { Game3rdTransfer, displayBalance } from './Game3rdTransfer';
import HandlerError from 'helper/HandlerError';
import { list3RDGame } from 'interfaces/fundtransfer';
import { FaArrowRightArrowLeft, FaChevronDown, FaCircleExclamation, FaArrowsRotate } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';
import Modal from 'components/modal/Modal';
import OpenGame3RD from './OpenGame3RD';

interface GroupTransfer {
    name: string;
    gametype: string;
    child: Game3rdTransferModel[];
}

const MAIN = 'MAIN';
const MAIN_LABEL = 'Tài khoản chính';

const listAmountQuick = [
    { value: 200000, label: '200K' },
    { value: 500000, label: '500K' },
    { value: 1000000, label: '1TR' },
    { value: 5000000, label: '5TR' },
    { value: 10000000, label: '10TR' },
    { value: 20000000, label: '20TR' },
    { value: 50000000, label: '50TR' },
    { value: 100000000, label: '100TR' },
    { value: 300000000, label: '300TR' },
];

const fmt = (n: number) => new Intl.NumberFormat().format(Math.max(0, Math.round(n)));

function FundTransfer() {
    const dispatch = useAppDispatch();
    const listTransferLoadedBalance = useRef<Game3rdTransferModel[]>([]);
    const { userInfo } = useAppSelector((state: RootState) => state.auth);
    const { menuGame } = useAppSelector((state: RootState) => state.system);

    const [accountFrom, setAccountFrom] = useState<'MAIN' | string>('MAIN');
    const [accountTo, setAccountTo] = useState<'MAIN' | string>('');
    const [listTransfer, setListTransfer] = useState<Game3rdTransferModel[]>([]);
    const [amount, setAmount] = useState('');
    const [group3rdGameList, setGroup3rdGameList] = useState<GroupTransfer[]>([]);
    const [balanceTotal, setBalanceTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showGame, setShowGame] = useState(false);
    const [loadFundTransfer, setLoadFundTransfer] = useState(false);

    const [listGam3RD, setListGam3RD] = useState<itemGame3RD[]>([]);

    useEffect(() => {
        if (menuGame.length > 0 && listTransfer.length > 0) {
            mapGameLoadedIntoGroupTransfer(listTransfer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menuGame, listTransfer]);

    useEffect(() => {
        const ListGame3RD: Game3rdTransferModel[] = JSON.parse(JSON.stringify(list3RDGame));

        setListTransfer(ListGame3RD);
        setAccountTo(ListGame3RD[0].providercode);
    }, []);

    useEffect(() => {
        if (listTransfer.length > 0 && userInfo.balance) {
            const totalBalance = listTransfer.reduce((acc, game) => {
                let balanceGameItem = 0;
                if (game.balance) {
                    balanceGameItem = Number(game.balance);
                }
                return acc + balanceGameItem;
            }, Number(userInfo.balance));

            setBalanceTotal(totalBalance);
        }
    }, [listTransfer, userInfo]);

    const loadBalance3rd = async (action: string, providercode: string, isReload: boolean, cb?: () => void) => {
        let payload: any = {};
        if (providercode === 'IBC2') {
            payload = { action, platform: 1 };
        } else if (providercode === 'DG') {
            payload = { action, gameId: 'DG' };
        } else if (providercode === 'PRAG') {
            payload = { action, gameId: 'PRAG' };
        } else if (providercode === 'EVOLUTION') {
            payload = { action, gameId: 'EVOLUTION' };
        } else if (providercode === 'JILI') {
            payload = { action, gameId: 'JILI' };
        } else if (providercode === 'PGSOFT') {
            payload = { action, gameId: 'PGSOFT' };
        } else if (providercode === 'PT') {
            payload = { action, gameId: 'PT' };
        } else {
            payload = { action };
        }
        try {
            const { data }: any = await game3rdApi.checkBalance(payload);
            updateBalanceGame({ ...data, providercode }, isReload, cb);
        } catch (error) {
            console.log(error);
        }
    };

    const loadBalanceMain = async () => {
        try {
            const { data } = await authApi.getUserInfo();
            HandlerError(
                data,
                () => {
                    dispatch(cacheUserInfo(data));
                },
                'getUserInfo'
            );
        } catch (error) {
            console.log(error);
        }
    };

    const actionFundTransfer = (value: string, idGame: string) => {
        setAmount('');
        if (value === 'MAIN') {
            setAccountFrom('MAIN');
            setAccountTo(idGame);
        } else {
            setAccountTo('MAIN');
            setAccountFrom(value);
        }
        setLoadFundTransfer(true);
    };

    const updateBalanceGame = (data: Game3rdTransferModel, isReload: boolean, cb?: () => void) => {
        if (!isReload) {
            listTransferLoadedBalance.current.push({ ...data, isLoaded: true });
            //check đã load toàn bộ số dư game 3
            if (listTransferLoadedBalance.current.length === listTransfer.length) {
                const newListTransfer = listTransfer.map((game) => {
                    const gameMap = listTransferLoadedBalance.current.find((gameLoaded) => game.providercode === gameLoaded.providercode);
                    if (gameMap) {
                        return { ...game, ...gameMap };
                    }
                    return game;
                });
                mapGameLoadedIntoGroupTransfer(listTransferLoadedBalance.current);
                newListTransfer.forEach((item: any) => {
                    if (item.cmdUserBalan) {
                        item.balance = item.cmdUserBalan.betAmount;
                    }
                });
                setListTransfer(newListTransfer);
            }
        } else {
            const newListTransfer = listTransfer.map((game) => {
                if (game.providercode === data.providercode) {
                    return { ...game, ...data };
                }
                return game;
            });
            newListTransfer.forEach((item: any) => {
                if (item.cmdUserBalan) {
                    item.balance = item.cmdUserBalan.betAmount;
                }
            });
            handleBalanceGameReload(data, cb);
            setListTransfer(newListTransfer);
        }
    };

    const mapGameLoadedIntoGroupTransfer = (listGame: Game3rdTransferModel[]) => {
        let groupTransfer: GroupTransfer[] = menuGame
            .filter((item) => !item.isMain)
            .map((item) => ({ name: item.name, gametype: item.gametype || '', child: [] }));
        groupTransfer = groupTransfer.map((group) => {
            const groupGameList: Game3rdTransferModel[] = [];
            listGame.forEach((game) => {
                if (game.gameType === group.gametype) {
                    groupGameList.push(game);
                }
            });
            return { ...group, child: groupGameList };
        });
        setGroup3rdGameList(groupTransfer);
    };

    const handleBalanceGameReload = (data: Game3rdTransferModel, cb?: () => void) => {
        const newGroup3rdGame = group3rdGameList.map((group) => {
            const newChildGameList = group.child.map((game) => {
                if (game.providercode === data.providercode) {
                    return { ...game, ...data };
                }
                return game;
            });
            return {
                ...group,
                child: newChildGameList,
            };
        });
        setGroup3rdGameList(newGroup3rdGame);
        if (cb) cb();
    };

    /* ---------------------------------------------------------------
     * Dẫn xuất cho giao diện. Mọi giao dịch luôn là MAIN <-> 1 game,
     * nên chỉ cần biết "game nào" + "chiều nào", không cần 2 dropdown.
     * ------------------------------------------------------------- */
    const isDeposit = accountFrom === MAIN; // MAIN -> game
    const selectedCode = isDeposit ? accountTo : accountFrom;
    const selectedGame = useMemo(
        () => listTransfer.find((g) => g.providercode === selectedCode),
        [listTransfer, selectedCode]
    );

    const mainBalance = Number(userInfo.balance || 0);
    const gameBalance = selectedGame ? displayBalance(selectedGame) : 0;
    const sourceBalance = isDeposit ? mainBalance : gameBalance;
    const sourceName = isDeposit ? MAIN_LABEL : selectedGame?.balancename || '—';
    const destName = isDeposit ? selectedGame?.balancename || '—' : MAIN_LABEL;
    const destBalance = isDeposit ? gameBalance : mainBalance;

    /** Đổi game đang chọn, giữ nguyên chiều chuyển. */
    const changeGame = (code: string) => {
        setAmount('');
        if (isDeposit) {
            setAccountTo(code);
            setAccountFrom(MAIN);
        } else {
            setAccountFrom(code);
            setAccountTo(MAIN);
        }
    };

    /** Đảo chiều chuyển, giữ nguyên game đang chọn. */
    const swapDirection = () => {
        setAmount('');
        if (isDeposit) {
            setAccountFrom(selectedCode);
            setAccountTo(MAIN);
        } else {
            setAccountFrom(MAIN);
            setAccountTo(selectedCode);
        }
    };

    /**
     * Soi lỗi ngay khi gõ. Điều kiện phản chiếu ĐÚNG submitTransfer bên dưới,
     * để cảnh báo trước khi bấm chứ không phải sau.
     */
    const validationError = useMemo(() => {
        if (!amount) return '';
        if (!selectedGame) return 'Không tìm thấy game được chọn';
        if (selectedGame.msg) return 'Game được chọn đang bảo trì!';

        const rawAmount = Number(removeSeperateNumber(amount));
        if (!rawAmount) return 'Vui lòng nhập số tiền';

        const moneyRate = selectedGame.money || 1;
        const isSG = selectedGame.providercode === 'SG';
        const amountTransfer = isSG ? rawAmount : rawAmount / moneyRate;
        const amountBase = amountTransfer * moneyRate;

        if (amountBase % 1000 !== 0 || amountBase < 1000) {
            return 'Số tiền phải chia hết cho 1,000 và tối thiểu 1,000 VNĐ';
        }
        if (isDeposit) {
            if (amountTransfer > 5e8) return 'Số tiền giao dịch nhiều nhất là 500,000,000';
            if (mainBalance < amountTransfer) return 'Tài khoản chính không đủ';
        } else {
            if (amountBase > 1e8) return 'Số tiền giao dịch nhiều nhất là 100,000,000';
        }
        return '';
    }, [amount, selectedGame, isDeposit, mainBalance]);

    const canSubmit = Boolean(amount) && !validationError && !loading;

    /** Trần cho nút "Tất cả": số dư nguồn, làm tròn xuống bội số 1,000. */
    const maxAmount = useMemo(() => {
        const cap = isDeposit ? 5e8 : 1e8;
        return Math.floor(Math.min(sourceBalance, cap) / 1000) * 1000;
    }, [sourceBalance, isDeposit]);

    const quickAmounts = useMemo(
        () => listAmountQuick.filter((item) => item.value <= Math.max(maxAmount, 0)).slice(-3),
        [maxAmount]
    );

    const previewPoint = useMemo(() => {
        if (!amount || !selectedGame || !isDeposit) return 0;
        const rawAmount = Number(removeSeperateNumber(amount));
        const moneyRate = selectedGame.money || 1;
        return selectedGame.providercode === 'SG' ? rawAmount : rawAmount / moneyRate;
    }, [amount, selectedGame, isDeposit]);

    const reloadAll = () => {
        loadBalanceMain();
        listTransfer.forEach((game) => {
            if (!game.msg) loadBalance3rd(game.action || '', game.providercode, true);
        });
    };

    const submitTransfer = async () => {
        if (!amount) {
            toast.error('Vui lòng nhập số tiền');
            return;
        }

        const rawAmount = Number(removeSeperateNumber(amount));
        const isDepositAction = accountFrom === 'MAIN';
        const isWithdraw = accountTo === 'MAIN';

        const gameSelect = listTransfer.find((game) =>
            isDepositAction ? game.providercode === accountTo : game.providercode === accountFrom
        );

        if (!gameSelect) {
            toast.error('Không tìm thấy game được chọn');
            return;
        }

        if (gameSelect.msg) {
            toast.error('Game được chọn đang bảo trì!');
            return;
        }

        const moneyRate = gameSelect.money || 1;
        const isSG = gameSelect.providercode === 'SG';
        const amountTransfer = isSG ? rawAmount : rawAmount / moneyRate;
        const amountBase = amountTransfer * moneyRate;

        if (amountBase % 1000 !== 0 || amountBase < 1000) {
            toast.error('Số tiền giao dịch phải chia hết cho 1,000 và lớn hơn hoặc bằng 1,000');
            return;
        }

        let direction = 1;
        let platform = 0;
        let apiTransfer = isDepositAction ? gameSelect.actiond : gameSelect.actionw;

        if (isDepositAction) {
            if (amountTransfer > 5e8) {
                toast.error('Số tiền giao dịch nhiều nhất là 500,000,000');
                return;
            }
            if (Number(userInfo.balance) < amountTransfer) {
                toast.error('Tài khoản chính không đủ');
                return;
            }
            platform = accountTo === 'WM' ? 10 : 5;
            if (accountTo === 'DG') direction = 1;
            if (accountTo === 'IBC2') direction = 5;
        } else if (isWithdraw) {
            if (amountBase > 1e8) {
                toast.error('Số tiền giao dịch nhiều nhất là 100,000,000');
                return;
            }
            if (accountFrom === 'DG') direction = 0;
            if (accountFrom === 'PRAG') direction = 0;
            if (accountFrom === 'HABA') direction = 0;
            if (accountFrom === 'EVOLUTION') direction = 0;
            if (accountFrom === 'IBC2') direction = 0;
            // Các game new-struct 1:1 (game3rdTransfer) rút ra cũng dùng direction=0 — khớp app (directionWithdraw=0)
            if (accountFrom === 'JILI') direction = 0;
            if (accountFrom === 'PGSOFT') direction = 0;
            if (accountFrom === 'PT') direction = 0;
            platform = 0;
        }

        let payloadFund: object = {};

        switch (gameSelect.providercode) {
            case 'AG':
                payloadFund = { action: apiTransfer, direction: platform, amount: amountTransfer / 1000 };
                break;
            case 'WM':
                payloadFund = { action: apiTransfer, direction: platform, amount: amountTransfer };
                break;
            case 'DG':
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer, gameId: 'DG' };
                break;
            case 'IBC':
                payloadFund = { action: apiTransfer, direction: platform, amount: amountTransfer, platform: 1 };
                break;
            case 'PRAG':
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer, gameId: 'PRAG' };
                break;
            case 'EVOLUTION':
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer, gameId: 'EVOLUTION' };
                break;
            case 'JILI':
                // JILI quy đổi 1:1 VND (money=1): gửi thẳng số VND người dùng nhập, như EVOLUTION.
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer, gameId: 'JILI' };
                break;
            case 'PGSOFT':
                // PG Soft quy đổi 1:1 VND (money=1): gửi thẳng số VND người dùng nhập.
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer, gameId: 'PGSOFT' };
                break;
            case 'PT':
                // Playtech quy đổi 1:1 VND (money=1): gửi thẳng số VND người dùng nhập.
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer, gameId: 'PT' };
                break;
            default:
                payloadFund = { action: apiTransfer, direction, amount: amountTransfer };
                break;
        }

        try {
            setLoading(true);

            const { data } = await game3rdApi.submitTransfer(payloadFund);
            if (!data.msg && !data.message) {
                if (gameSelect?.providercode && gameSelect?.port && isDepositAction) {
                    setShowGame(true);
                    setListGam3RD((prev) => [
                        ...prev,
                        {
                            providercode: gameSelect.providercode,
                            port: gameSelect.port,
                            valSname: gameSelect.valSname || '',
                            valSvalue: gameSelect.valSvalue || '',
                        },
                    ]);
                }
                if (isWithdraw) {
                    toast.success('Chuyển quỹ thành công');
                }
                setAmount('');
                loadBalanceMain();
                setLoadFundTransfer(false);
                loadBalance3rd(gameSelect.action || '', gameSelect.providercode, true);
            } else {
                toast.error(data.msg || data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi thực hiện giao dịch');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={accountStyles.wrap}>
                <div className={styles.wrap}>
                    {/* Tổng quan số dư */}
                    <div className={styles.balanceMain}>
                        <div className={styles.balanceBlock}>
                            <span className={styles.balanceLabel}>Tổng số dư</span>
                            <span className={styles.balanceValueMain}>{fmt(balanceTotal)} VNĐ</span>
                        </div>
                        <div className={styles.balanceDivider} />
                        <div className={styles.balanceBlock}>
                            <span className={styles.balanceLabel}>{MAIN_LABEL}</span>
                            <span className={styles.balanceValueSub}>{fmt(mainBalance)} VNĐ</span>
                        </div>
                        <button type="button" className={styles.btnRefreshAll} onClick={reloadAll}>
                            <FaArrowsRotate size={13} />
                            <span>Làm mới</span>
                        </button>
                    </div>

                    {/* Lưới ví game */}
                    <div className={styles.gameWrap}>
                        {group3rdGameList.map((group, idx) => (
                            <div className={styles.gameGroup} key={idx}>
                                {group.child.length > 0 && <h6 className={styles.gameGroupTitle}>{group.name}</h6>}
                                <div className={styles.gameList}>
                                    {group.child &&
                                        group.child.map((game, idxGame) => (
                                            <Game3rdTransfer
                                                key={idxGame}
                                                gameData={game}
                                                onActionFund={actionFundTransfer}
                                                onLoadBalance={loadBalance3rd}
                                            />
                                        ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Bảng chuyển quỹ */}
            <Modal isShow={loadFundTransfer} onClose={() => setLoadFundTransfer(false)} width="392px" closeClickBackdrop>
                <div className={styles.panel}>
                    <div className={styles.heading}>
                        <h6 className={styles.title}>Chuyển quỹ</h6>
                        <button type="button" className={styles.btnClose} onClick={() => setLoadFundTransfer(false)}>
                            <IoMdClose size={20} />
                        </button>
                    </div>

                    {/* Hướng chuyển: nguồn -> đích, bấm nút giữa để đảo chiều */}
                    <div className={styles.route}>
                        <div className={styles.routeCard}>
                            <span className={styles.routeRole}>Từ</span>
                            <span className={styles.routeName}>{sourceName}</span>
                            <span className={styles.routeBalance}>{fmt(sourceBalance)} VNĐ</span>
                        </div>
                        <button type="button" className={styles.btnSwap} onClick={swapDirection} title="Đảo chiều chuyển">
                            <FaArrowRightArrowLeft size={15} />
                        </button>
                        <div className={styles.routeCard}>
                            <span className={styles.routeRole}>Đến</span>
                            <span className={styles.routeName}>{destName}</span>
                            <span className={styles.routeBalance}>{fmt(destBalance)} VNĐ</span>
                        </div>
                    </div>

                    {/* Chọn ví game */}
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="gameSelect">
                            Ví game
                        </label>
                        <div className={styles.selectWrap}>
                            <select
                                id="gameSelect"
                                className={styles.select}
                                value={selectedCode}
                                onChange={(e) => changeGame(e.target.value)}
                            >
                                {listTransfer.map((item, idx) => (
                                    <option value={item.providercode} key={idx} disabled={Boolean(item.msg)}>
                                        {item.balancename}
                                        {item.msg ? ' — đang bảo trì' : ''}
                                    </option>
                                ))}
                            </select>
                            <FaChevronDown size={13} />
                        </div>
                    </div>

                    {/* Số tiền */}
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="amountInput">
                            Số tiền
                        </label>
                        <div className={`${styles.amountBox} ${validationError ? styles.amountInvalid : ''}`}>
                            <NumericFormat
                                id="amountInput"
                                className={styles.amountInput}
                                thousandSeparator=","
                                placeholder="0"
                                inputMode="numeric"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                            <span className={styles.amountUnit}>VNĐ</span>
                        </div>

                        <div className={styles.chipRow}>
                            {quickAmounts.map((item) => (
                                <button
                                    type="button"
                                    key={item.value}
                                    className={`${styles.chip} ${
                                        Number(removeSeperateNumber(amount)) === item.value ? styles.chipActive : ''
                                    }`}
                                    onClick={() => setAmount(String(item.value))}
                                >
                                    {item.label}
                                </button>
                            ))}
                            <button
                                type="button"
                                className={`${styles.chip} ${styles.chipMax} ${
                                    maxAmount > 0 && Number(removeSeperateNumber(amount)) === maxAmount ? styles.chipActive : ''
                                }`}
                                disabled={maxAmount <= 0}
                                onClick={() => setAmount(String(maxAmount))}
                            >
                                Tất cả
                            </button>
                        </div>

                        {validationError ? (
                            <p className={styles.errorText}>
                                <FaCircleExclamation size={13} />
                                {validationError}
                            </p>
                        ) : (
                            <div className={styles.hintRow}>
                                <span>Tối thiểu 1,000 VNĐ</span>
                                <span>Tối đa {isDeposit ? '500,000,000' : '100,000,000'} VNĐ</span>
                            </div>
                        )}
                    </div>

                    {/* Quy đổi điểm cược khi chuyển vào game */}
                    {isDeposit && selectedGame && Number(selectedGame.money) > 1 && (
                        <div className={styles.convertBox}>
                            <span>
                                {fmt(Number(selectedGame.money))} VNĐ = 1 điểm cược tại {selectedGame.balancename}
                            </span>
                            {previewPoint > 0 && <span className={styles.convertValue}>≈ {fmt(previewPoint)} điểm</span>}
                        </div>
                    )}

                    <button type="button" className={styles.btnSubmit} disabled={!canSubmit} onClick={submitTransfer}>
                        {loading ? 'ĐANG XỬ LÝ…' : 'XÁC NHẬN CHUYỂN QUỸ'}
                    </button>
                </div>
            </Modal>

            {loading && <LoadingIcon />}

            <Modal isShow={showGame} onClose={() => setShowGame(false)} width="460px">
                <OpenGame3RD
                    key={`${listGam3RD[0]?.providercode}-${listGam3RD[0]?.port}`}
                    itemGame={listGam3RD[listGam3RD.length - 1]}
                    onClose={() => setShowGame(false)}
                />
            </Modal>
        </>
    );
}

export default FundTransfer;
